import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA, textFormatEditor } from "../../../../../utils/commonFunctions";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";

const TitleColumn: ColDef = {
  field: "title",
  headerName: "Title",
  cellRenderer: (props: any) => {
    return renderNA(props.data.title);
  },
};
const industryColumn: ColDef = {
  ...generateColumn("", `industries`),

  cellRenderer: (props: any) => {
    return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
  },
  filterValueGetter: (props: any) => {
    return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
  },
  tooltipValueGetter: (props: any) => {
    return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
  },
  valueGetter: (props: any) => {
    return props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.join("#");
  },
};

const AcronymColumn: ColDef = {
  field: "acronym",
  headerName: "Acronym",
  cellRenderer: (props: any) => {
    return renderNA(props.data.acronym);
  },
};



const useColumnDefs = [
  idColumn,
  AcronymColumn,
  TitleColumn,
  industryColumn,
  {
    ...generateColumn("", "description"),
    ...textFormatEditor("description"),
  },
  statusColumn,
  { ...actionColumn, width: 195, minWidth: 195 },
];

export default useColumnDefs;
